import { Component, OnInit, Input, OnDestroy, EventEmitter } from '@angular/core';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { FilteringService } from 'src/app/services/filtering.service';
import * as moment from 'moment-timezone';
import { Subscription, Observable } from 'rxjs';
// const momentZ = require('moment-timezone');
@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.less']
})
export class ChangeLogComponent implements OnInit, OnDestroy {
  @Input() reportNumber : number;
  @Input() screeningId : number;
  @Input() updates : Observable<void>;
  @Input() onRelease: EventEmitter<ReportReleasedModel>;
  changeLogs : ScreeningChangeLogs;
  pitLgos : PITUpdate[];
  loading: boolean = false;
  getupdates : Subscription;
  constructor(public screening : ScreeningService, public filters : FilteringService) { 
    //console.error('change log report number',this.reportNumber)
  }
  ngOnDestroy(): void {
    this.getupdates.unsubscribe();
  }

  ngOnInit() {
    // this.loading = true;
    this.reload();
    this.getupdates = this.updates.subscribe(()=>{ this.reload();});
    
  }

  reload() {
    // this.loading = true;
    this.screening.GetScreeningChangeLogs(this.reportNumber).subscribe((rsp:ScreeningChangeLogs)=>{
      let harddeclines = new Array<HardDeclineStatRecord>();
      rsp.hardDeclineStats.forEach(element => {
        let obj = Object.assign(new HardDeclineStatRecord(),element)
        harddeclines.push(obj);
      });
      rsp.hardDeclineStats = harddeclines;
      this.changeLogs = rsp;
      //RIQ-3223: the sproc that pulls the release logs orders by date desc, so this is a safe assumption for now ?
      this.onRelease.next(rsp.releaseStats[0]);
    });

    this.screening.GetScreeningPITLogs(this.screeningId,this.reportNumber).subscribe((rsp: PITUpdate[])=>{
      this.pitLgos = rsp;
    
      // console.log(this.pitLgos);
    },(err:any)=>{
      // console.warn(err);
    })
  }

}

export class ConsumerDisclosureStatRecord {
    id: number;
    reportNumber: number;
    screeningId: number;
    dateSent: Date | string;
    initiatingUser: number;
    disclosureSentTo: string;
    userName: string;
}


export class HardDeclineStatRecord { 
    id: number;
    screeningId: number;
    reasonId: number;
    userId: number;
    declineNote: string;
    isCrimGrid: boolean;
    actionType: HardDeclineActionTypes;
    actionDate: Date | string;
        
    public get actionTypeString() : string {
      if(this.actionType == 0) 
      return 'Reason Added' 
      
      if(this.actionType == 2) return 'Override Removed';
      else return 'Reason Removed';
    }
    
    
}

export enum HardDeclineActionTypes { 
    added = 0,
    removed = 1,
    overrideRemove = 2
}

export interface ReportReleasedModel {
    releaseDate: Date | string;
    screeningId: number;
    reportNumber: number;
    orderDecision: string;
    vendorResponse: string;
    userId: number | null;
    
}

export interface ScreeningChangeLogs { 
    pipelineStats: SearchEntryStatLog[];
    releaseStats: ReportReleasedModel[];
    hardDeclineStats: HardDeclineStatRecord[];
    propertyDecisionStats : PropertyDecisionStatRecord[];
    consumerDisclosureLogs : ConsumerDisclosureStatRecord[];
    closureLog: ReportClosedStatRecord;
}


export interface PITUpdate { 
    userId: number;
    timestamp: Date | string;
    propertyName: string;
    oldValue: string;
    newValue: string;
    userName : string;
}

export interface SearchEntryStatLog { 
    reportNumber: number;
    name: string;
    oldPipelineStage: string;
    newPipelineStage: string;
    timestamp: Date | string;
    userInvolved: string;
}

export interface PropertyDecisionStatRecord {
    id: number;
    oldDecision: string;
    newDecision: string;
    screeningId: number;
    userId: number;
    timeStamp: Date | string;
    userName : string;
}

export interface ReportClosedStatRecord {
    id: number;
    reportNumber: number;
    screeningId: number;
    dateCancelled: Date | string;
    propertyId: number;
    reason: string;
    closingUserName: string;
}